import './product.css';

import type {ProductData} from '../../types/types.ts';
import {renderDigitalEditionCover, renderPrintEditionCover} from '../components/edition-cover.ts';
import {renderApiError} from '../components/error.ts';
import {render as resourceStar} from '../components/wc/resource-star.ts';
import {createElement} from '../lib/dom';
import {getClientId} from '../lib/storage.ts';
import {getLocaleForClient} from '../models/edition-factory.ts';
import {loadRecentDigitalEditionsForProduct, loadRecentEditionsForProduct} from '../services/content';

export async function renderPrintProductPage(appEl: HTMLElement, productData: ProductData) {
	const editionsEl = createElement(appEl.ownerDocument, 'div', 'editions');
	editionsEl.innerHTML = 'Loading editions …';
	appEl.appendChild(editionsEl);

	const editionsResponse = await loadRecentEditionsForProduct(productData.attributes.name);

	if (editionsResponse.status !== 200) {
		editionsEl.innerHTML = renderApiError(editionsResponse.body, 'Error loading editions');
		return;
	}

	const locale = getLocaleForClient(getClientId());

	editionsEl.innerHTML = `<div>
	<a href="/home">Home</a> |
	${productData.attributes.title}
	${resourceStar({
		type: 'print-product',
		id: productData.id,
		label: productData.attributes.title,
		path: `/print-products/${productData.attributes.name}`
	})}
</div>`;

	editionsResponse.body.forEach((editionListing) => {
		const editionEl = createElement(appEl.ownerDocument, 'div', 'edition');
		editionEl.innerHTML = renderPrintEditionCover(editionListing, productData, locale);
		editionsEl.appendChild(editionEl);
	}, Promise.resolve());
}

export async function renderDigitalProductPage(appEl: HTMLElement, productData: ProductData) {
	const editionsEl = createElement(appEl.ownerDocument, 'div', 'editions');
	editionsEl.innerHTML = 'Loading editions …';
	appEl.appendChild(editionsEl);

	const editionsResponse = await loadRecentDigitalEditionsForProduct(productData.attributes.name);

	if (editionsResponse.status !== 200) {
		editionsEl.innerHTML = renderApiError(editionsResponse.body, 'Error loading editions');
		return;
	}

	editionsEl.innerHTML = `<div>
	<a href="/home">Home</a> |
	${productData.attributes.title}
		${resourceStar({
			type: 'digital-product',
			id: productData.id,
			label: productData.attributes.title,
			path: `/digital-products/${productData.attributes.name}`
		})}
</div>`;

	await editionsResponse.body.reduce(async (acc, curr) => {
		await acc;
		const editionEl = createElement(appEl.ownerDocument, 'div', 'edition');
		editionEl.innerHTML = renderDigitalEditionCover(curr, productData);
		// non-archived editions will render as empty
		if (editionEl.innerHTML) {
			editionsEl.appendChild(editionEl);
		}
	}, Promise.resolve());
}
